import React, {useContext, useEffect, useState} from 'react';
import {NoteBookReportContext} from "./NoteBookReportContext";
import _axios from "../../../httpService";
import {prefixUrl} from "../../../utils/utilsData";
import {toast} from "react-toastify";
import {SetPrintDataContext} from "../../../Pages";
import {useNavigate} from "react-router-dom";
import SecondFilterTable from "./SecondFilterTable";
import utilsFunction from "../../../utils/utilsFunction";
import {exportXLSXFile} from "../../../utils/exportCSVFile";

function Section2NoteBookReport(props) {

  const helper = useContext(NoteBookReportContext);
  const setData = helper.setData
  const data = helper.data
  // تب ها در واقع هر چی بک فرستاده باید بریزم توی آرایه و به تعدادش تب بسازم.
  const [tabs, setTabs] = useState([])

  const [selectedTab, setSelectedTab] = useState("group");

  const setprint = useContext(SetPrintDataContext);
  let navigate = useNavigate();

  useEffect(() => {
    const data1Keys = Object.keys(data.data1)
    setTabs(data1Keys)
    // set default selectedTab
    setSelectedTab(data1Keys[0])

  }, [data.data1]);

  const nazir = {
    group: "گروه", kol: "کل", moien: "معین", tafsil: "تفصیل",
  }

  const handleReport = async () => {

    try {
      const temp = {
        level: data.level, reportType: data.reportType, filter: data.filter, prevFilter: data.prevFilter,
      }
      const res = await _axios.post(prefixUrl() + "/accountingLedger/?request=ledgerReport", temp);
      if (res.data.status) {
        toast.success("داده ها آماده پرینت هستند")

        let sendData
        if (temp.reportType === '1') {
          sendData = {
            type: "NoteBookReportPrint", data: res,
          }
        } else {
          sendData = {
            type: "NoteBookReportPrintTypeTwo", data: res,
          }
        }

        setprint(sendData);
        navigate("/factorprint");
      } else {
        toast.error(res.data.message)

      }
    } catch (error) {
      toast.error(error)
    }

  }

  const handleReportXL = async () => {
    try {
      const temp = {
        level: data.level, reportType: "1", filter: data.filter, prevFilter: data.prevFilter,
      }
      const res = await _axios.post(prefixUrl() + "/accountingLedger/?request=ledgerReport", temp);
      debugger
      if (res.data.status) {
        toast.success("داده ها آماده اکسل هستند")
        let tempColumn = [...res.data.data.column]
        let tempData = []

        tempColumn.unshift(
          {field: 'groupCode', title: 'کد گروه'},
          {field: 'kol', title: 'کل'},
          {field: 'moein', title: 'معین'},
          {field: 'tafsil', title: 'تفصیل'}
        )

        res.data.data.data.forEach((v) => {
          v.data.forEach((q) => {
            q.groupCode = v.accountsList[0]
            q.kol = v.accountsList[1]
            q.moein = v.accountsList[2]
            q.tafsil = v.accountsList[3]
            tempData.push(q)
          })
        })

        const format = {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        };
        const fileName = "گزارش دفاتر" + new Date().toLocaleDateString("fa-ir", format);
        const normalizeData = utilsFunction.convertTabulatorDataToJson(tempColumn, tempData)
        exportXLSXFile(normalizeData, fileName, "")
      } else {
        toast.error(res.data.message)
      }
    } catch (error) {
      toast.error(error)
    }
  }


  try {
    return (<div className={"second__filter"}>

      <div className={"fw-bold w__400px"}>
        <div>
          <div className={"tabs d-flex justify-content-start align-items-center"}>{tabs.map((item, index) => {
            return <button
              key={index}
              style={{width: 80,}}
              onClick={() => setSelectedTab(item)}
              className={`mx-2 py-2 px-3 btn__note__book ${selectedTab === item ? 'bg__color__D9DCEA' : 'bg__color__F1F1F1'}`}
            >{nazir[item]}</button>
          })}</div>

        </div>
        <div className={"text-center fw-bold py-1 bg__color__F1F1F1 w-100 my-2"} style={{borderRadius: 5}}>الویت بندی
          حساب
          ها
        </div>


        {/*{console.log(data?.data1[selectedTab])}*/}
        {/*{selectedTab==="group" && <SecondFilterTable data1={data?.data1[selectedTab]} selectedTab={selectedTab} />}*/}
        {/*{selectedTab==="kol" && <SecondFilterTable data1={data?.data1[selectedTab]} selectedTab={selectedTab} />}*/}


        <div>

          {data?.data1["group"] &&
            <div className={`${selectedTab === 'group' ? 'd-block' : 'd-none'}`}><SecondFilterTable
              data1={data?.data1["group"]} selectedTab={selectedTab}/></div>}

          {data?.data1["kol"] && <div className={`${selectedTab === 'kol' ? 'd-block' : 'd-none'}`}>
            <SecondFilterTable
              data1={data?.data1["kol"]} selectedTab={selectedTab}/></div>}

          {data?.data1["moien"] &&
            <div className={`${selectedTab === 'moien' ? 'd-block' : 'd-none'}`}><SecondFilterTable
              data1={data?.data1["moien"]} selectedTab={selectedTab}/></div>}
          {data?.data1["tafsil"] &&
            <div className={`${selectedTab === 'tafsil' ? 'd-block' : 'd-none'}`}><SecondFilterTable
              data1={data?.data1["tafsil"]} selectedTab={selectedTab}/></div>}
        </div>

        {/*{Object.keys(nazir).map(v => {*/}
        {/*  if (data?.data1[selectedTab] === v) {*/}
        {/*    return <SecondFilterTable data1={data?.data1[selectedTab]} selectedTab={selectedTab}/>*/}
        {/*  }*/}
        {/*})}*/}


        <div>
          <button className={"btn btn__secondary_purple wh104x28font14 p-0 m-2 my-2"}


                  onClick={() => {
                    props.setShow("section1")
                  }}
          > فیلتر اولیه
          </button>
          <button
            onClick={handleReport}
            className={"btn btn__secondary_purple wh104x28font14 p-0 m-2"}> گزارش گیری
          </button>

          <button
            onClick={handleReportXL}
            className={"btn btn__secondary_purple wh104x28font14 p-0 m-2"}> خروجی اکسل
          </button>

        </div>
      </div>


    </div>);
  } catch (error) {
    return <>{error.toString()}</>
  }

}

export default Section2NoteBookReport;